import type {
  DtoApplication,
  DtoApplicationBorrower,
} from "@porchpass/api-client";
import type { BorrowerInviteHandlerParams } from "src/types/dashboard";
import type { SetUserDataProps } from "../../types";

export const setInvitedMainBorrowerUserData = (
  application: DtoApplication,
  authBorrower: DtoApplicationBorrower,
  mainBorrower: string | undefined,
  setUserData?: SetUserDataProps,
) => {
  const application_id = application.id;
  const { is_primary, status } = authBorrower;

  setUserData?.((prev) => ({
    ...prev,
    status,
    is_primary,
    application_id: application_id,
    borrower_id: mainBorrower,
    auth_user_borrower_id: mainBorrower,
    dealer_id: application.dealer?.id,
    roles: {
      borrower: mainBorrower,
      coborrowers: [],
    },
  }));
};

export const handleMainBorrowerInviteRoute = (
  application: DtoApplication,
  authBorrower: DtoApplicationBorrower,
  mainBorrower: string | undefined,
  { setUserData, navigate, dealerName }: BorrowerInviteHandlerParams,
) => {
  setInvitedMainBorrowerUserData(
    application,
    authBorrower,
    mainBorrower,
    setUserData,
  );
  console.log(
    `Redirecting to invited borrower registration for ${application.id}`,
  );
  navigate(`/${dealerName}/register`);
};
